import React from 'react';
import { DividedTabSection } from '../TabSections';
import { SECTIONS } from '../constants';

const { DESCRIPTION, TITLE } = SECTIONS.COMMUNITY;

const Community = () => {
  return (
    <DividedTabSection description={DESCRIPTION} title={TITLE}>
      {/* TODO - remove TITLE placeholder with section content */}
      <div>{TITLE}</div>
    </DividedTabSection>
  );
};

export default Community;
